import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { CmxFooterComponent } from './cmx-footer.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
  ],
  exports: [
    CmxFooterComponent,
  ],
  declarations: [
    CmxFooterComponent,
  ],
})
export class CmxFooterModule { }
